import { flow, upperFirst } from 'lodash';
import { Profile } from '~/types/models';

import { getProfileFirstName } from '../../util';

const MAX_LENGTH = 30;
const THRESHOLD = 20;

function generateHeaderText(names: string[]): string {
  const list = [...names];

  if (list.length === 1) {
    return list[0];
  }

  return generateHeaderTextRecursive(list[0], list.slice(1));
}

function generateHeaderTextRecursive(
  current: string,
  remaining: string[]
): string {
  const next = remaining[0];
  const isLast = remaining.length === 1;

  let result = '';
  if (isLast) {
    result = `${current} & ${next}`;
  } else {
    result = `${current}, ${next}`;
  }

  if (isLast && result.length <= MAX_LENGTH) {
    return result;
  } else if (result.length > THRESHOLD) {
    return `${current} & ${remaining.length} other${isLast ? '' : 's'}`;
  }

  return generateHeaderTextRecursive(result, remaining.slice(1));
}

export function getTodoMultiName(profiles: Profile[]) {
  const names = profiles.map(flow(getProfileFirstName, upperFirst));

  return generateHeaderText(names);
}
